import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  cta?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  cta,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('grid place-items-center px-6 py-16 text-center', className)}>
      {Icon && (
        <div className="mb-4 grid h-12 w-12 place-items-center rounded-lg bg-blue-10 text-blue">
          <Icon size={22} strokeWidth={2} />
        </div>
      )}
      <h3 className="text-base font-bold tracking-tight text-neutral-ink">{title}</h3>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-neutral-muted">{description}</p>
      )}
      {cta && <div className="mt-4">{cta}</div>}
    </div>
  );
}
